import { Logger, OrganizationService, PreviewMode, UtilityService } from 'src/app/@shared';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { MatDialog } from '@angular/material/dialog';
import { ActivityLogDetailsDialogComponent } from 'src/app/@shared/components/activity-log-details-dialog/activity-log-details-dialog.component';
import {
  Offer,
  OfferDomain,
  OfferPromo,
  OfferPromoService,
  OfferService,
  OfferTag,
  PromoDomain,
} from '../..';
import { Observable, Subscription, of, tap } from 'rxjs';
import { AuthorizationService } from 'src/app/@shared/services/authorization.service';
import { Status } from '../../models/offer-promo-status';
import * as dayjs from 'dayjs';

const log = new Logger('OfferAssetsComponent');

@Component({
  selector: 'app-promo-activitylog',
  templateUrl: './promo-activity-log.component.html',
  styleUrls: ['./promo-activity-log.component.scss'],
})
export class PromoActivityLogComponent<
  T extends Offer,
  Tag extends OfferTag,
  TOfferDomain extends OfferDomain<Offer>,
  TOfferPromo extends OfferPromo,
  TEvent extends Event,
  TPromoDomain extends PromoDomain<OfferPromo>
> implements OnInit, OnDestroy
{
  
  offer$: Observable<any> = of({} as PromoDomain<OfferPromo>);

  displayedColumns: string[] = ['activity', 'user', 'time', 'details'];
  public activityDataSource: any = [];
  public offerId: string = '';
  subscription$ = new Subscription();
  readOnlyMode: boolean = false;
  offerDetails: any;
  isPromo = false;
  PreviewMode = PreviewMode;
  constructor(
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private offerService: OfferService<Offer, OfferDomain<Offer>>,
    public utilityService: UtilityService,
    private authorizationService: AuthorizationService,
    private offerpromoService: OfferPromoService<TOfferPromo, TPromoDomain>
  ) {}

  ngOnInit(): void {
    this.offerId = this.route.snapshot.params['offerId'];
    this.offerpromoService.eventId = this.route.snapshot.params['eventId'];
    this.subscription$.add(
      this.offerService.getOfferLogs(this.offerId, true).subscribe((logs: any) => {
        this.activityDataSource = (logs as any[]).map((l) => ({
          Activity: l.ArchiveEdgeItem ? l.ArchiveEdgeItem.Activity : l.Activity,
          User: l.ArchiveEdgeItem ? l.ArchiveEdgeItem.UserName : l.UserName,
          Time: l.ArchiveEdgeItem ? l.ArchiveEdgeItem.ModifiedDate : l.ModifiedDate,
          Details: l.ArchiveEdgeItem ? l.ArchiveEdgeItem.OldNewPropertyValue : l.OldNewPropertyValue
        }));
      })
    );
  }

  viewDetails(i: number) {
    this.dialog.open(ActivityLogDetailsDialogComponent, {
      data: {
        details: this.activityDataSource[i]?.Details,
      },
      disableClose: true,
    });
  }

  offerResponseCallback = (offer: any) => {
    this.offerDetails = offer;
    this.offerService.currentRecord = JSON.parse(JSON.stringify(offer));
    if (offer && offer.Detail && offer.Detail.StartDate) {
      offer.Detail.StartDate = new Date(offer.Detail.StartDate);
    }
    if (offer && offer.Detail && offer.Detail.EndDate) {
      offer.Detail.EndDate = new Date(offer.Detail.EndDate);
    }
    const newVersionName = this.offerService.getNewVersion;
    if (newVersionName) {
      offer.Detail.ClientKey = '';
      // this.offerId = '0';
      offer.Detail.OfferVariantName = newVersionName;
    }
  };

  canEdit(): boolean {
    const hasAccess =
      this.authorizationService.checkAccess('edit||offermang') &&
      this.readOnlyMode != true;

    return hasAccess;
  }

  processCurrentOffer() {
    this.offerService.processOfferLogs(this.offerId, true).subscribe((logs: any) => {
      this.activityDataSource = (logs as any[]).map((l) => ({
        Activity: l.ArchiveEdgeItem ? l.ArchiveEdgeItem.Activity : l.Activity,
        User: l.ArchiveEdgeItem ? l.ArchiveEdgeItem.UserName : l.UserName,
        Time: l.ArchiveEdgeItem ? l.ArchiveEdgeItem.ModifiedDate : l.ModifiedDate,
        Details: l.ArchiveEdgeItem ? l.ArchiveEdgeItem.OldNewPropertyValue : l.OldNewPropertyValue
      }));
    })
  }

  ngOnDestroy() {
    this.subscription$.unsubscribe();
  }
}
